<template>
  <v-dialog v-model="showDialog" max-width="50%">
    <v-toolbar dark color="primary">
      <v-toolbar-title
        >Claim Funding - {{ this.claimID != '' ? this.claimID : this.patientID }}</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card tile>
      <v-card-text class="pt-3 pb-3">
        <v-row v-if="this.requestError == true && this.loading != true">
          <v-col>
            <v-alert type="error">Error getting claim data.</v-alert>
          </v-col>
        </v-row>
        <v-row v-else-if="this.requestError == false && this.loading != true">
          <v-col v-if="claim.PART_A > 0">
            <v-card outlined>
              <v-card-title>Part A</v-card-title>
              <v-card-text class="font-weight-bold">
                {{ formatCurrency(claim.PART_A) }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="claim.PART_B > 0">
            <v-card outlined>
              <v-card-title>Part B</v-card-title>
              <v-card-text class="font-weight-bold">
                {{ formatCurrency(claim.PART_B) }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="claim.PART_D > 0">
            <v-card outlined>
              <v-card-title>Part D</v-card-title>
              <v-card-text class="font-weight-bold">
                {{ formatCurrency(claim.PART_D) }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="claim.STOPLOSS > 0">
            <v-card outlined>
              <v-card-title>Stoploss (STLS)</v-card-title>
              <v-card-text class="font-weight-bold">
                {{ formatCurrency(claim.STOPLOSS) }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="text-center">
            <v-progress-circular
              indeterminate
              color="secondary"
              :size="50"
              :width="3"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ClaimFundTypes',
  props: ['value', 'insurance', 'claimID', 'patientID', 'startDate', 'endDate'],
  data() {
    return {
      dialog: false,
      loading: true,
      requestError: false,
      claim: [],
    };
  },
  methods: {
    async getClaim() {
      this.loading = true;
      this.requestError = false;
      this.claim = [];

      let url = '';

      if (this.patientID != '') {
        url = `api/claims/fundtypes/${this.insurance}/%20/${this.patientID}/${this.startDate}/${this.endDate}`;
      } else {
        url = `api/claims/fundtypes/${this.insurance}/${this.claimID}/${this.startDate}/${this.endDate}`;
      }

      const response = axios
        .get(url)
        .then((response) => {
          this.claim = response.data;
          this.loading = false;
        })
        .catch((error) => {
          this.requestError = true;
          this.loading = false;
        });
    },
    formatCurrency(c) {
      if (c != undefined) return `$${c.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async claimID() {
      if (
        (this.value == true && this.claimID != null && this.claimID != 0 && this.claimID != '') ||
        this.patientID != ''
      ) {
        this.getClaim();
      } else {
        this.loading = false;
        this.requestError = true;
      }
    },
    async patientID() {
      if (
        (this.value == true &&
          this.patientID != null &&
          this.patientID != 0 &&
          this.patientID != '') ||
        this.claimID != ''
      ) {
        this.getClaim();
      } else {
        this.loading = false;
        this.requestError = true;
      }
    },
  },
};
</script>
